import { render } from "./CookiesDropInputObject.vue?vue&type=template&id=30f317a6&scoped=true&ts=true"
import script from "./CookiesDropInputObject.vue?vue&type=script&lang=ts"
export * from "./CookiesDropInputObject.vue?vue&type=script&lang=ts"

import "./CookiesDropInputObject.vue?vue&type=style&index=0&id=30f317a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f317a6"]])

export default __exports__